import { Injectable } from '@angular/core';
import { InformationModalComponent } from './information-modal.component';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class InformationModalService {
  public modalInfo = {
    type: 'error',
    data: {
      title: 'Unknown Error',
    }
  };
  constructor(public modalService: NgbModal) { }
  open(inputModalInfo) {
    const defaultOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      centered: true
    };
    if (inputModalInfo && inputModalInfo.type && inputModalInfo.data && inputModalInfo.buttons) {
      this.modalInfo = inputModalInfo;
    }
    const modalRef = this.modalService.open(InformationModalComponent, defaultOptions);
    modalRef.componentInstance.inputInfo = this.modalInfo;
    return modalRef;
  }
}
